import type {MobileSlotConfig, MobileSlots, NumberParity} from './types'

/**
 * Check if a label contains an even or odd number
 */
export function getLabelNumberParity(label: string | undefined): NumberParity {
  if (!label) {
    return 'none'
  }

  const numbers = label.match(/\d+/g)

  if (!numbers || numbers.length === 0) {
    return 'none'
  }

  const firstNumber = parseInt(numbers[0], 10)

  return firstNumber % 2 === 0 ? 'even' : 'odd'
}

/**
 * Extract mobile slot from label and slots configuration
 */
export function getMobileSlot(label: string | undefined, mobileSlots?: MobileSlots): MobileSlotConfig | undefined {
  return label && mobileSlots ? mobileSlots[label] : undefined
}
